import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { href: 'https://github.com/tobiasharms-sec', icon: Github },
    { href: 'https://linkedin.com/in/tobiasharms', icon: Linkedin },
    { href: 'mailto:harms.tobias89@gmail.com', icon: Mail }
  ];

  return (
    <footer className="relative z-10 bg-black border-t border-green-500/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 mb-4 md:mb-0 font-mono text-sm">
            © 2025 TOBIAS.HARMS | SR.SALES.ENGINEER @ VECTRA.AI | MIAMI.FL
          </div>
          <div className="flex space-x-6">
            {socialLinks.map(({ href, icon: Icon }) => (
              <a key={href} href={href} className="text-gray-400 hover:text-green-400 transition-colors" target="_blank" rel="noopener noreferrer">
                <Icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;